import { LayerType, type IExportBehavior, type ILayerBehavior } from '@/version-types';
import {
    createEditingBehaviors,
    createFontBehaviors,
    createGetterBehaviors,
    createOperationBehaviors,
    createRendererBehaviors,
    createSaveBehaviors,
} from './behaviors';

const getBehavior = (identity: string) => {
    const rendererBehaviors = createRendererBehaviors(identity);
    const saveBehaviors = createSaveBehaviors(identity);
    const operationBehaviors = createOperationBehaviors(identity);
    const getterBehaviors = createGetterBehaviors(identity);
    const fontBehaviors = createFontBehaviors(identity);
    const editingBehaviors = createEditingBehaviors(identity);

    const layerBehavior: ILayerBehavior = {
        ...rendererBehaviors,
        ...saveBehaviors,
        ...operationBehaviors,
        ...getterBehaviors,
        ...fontBehaviors,
        ...editingBehaviors,
    };

    return layerBehavior;
};

export const behavior: IExportBehavior = {
    layerType: LayerType.TEXT_LAYER,
    getBehavior,
};
